var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34659_477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5C0 2.01472 2.01472 0 4.5 0H19.5C21.9853 0 24 2.01472 24 4.5V19.5C24 21.9853 21.9853 24 19.5 24H4.5C2.01472 24 0 21.9853 0 19.5V4.5ZM18.0169 20.3812L17.8237 18.9999C17.0646 19.0556 16.2384 18.7009 15.8925 17.6411C17.6743 16.4479 18.6637 14.9486 19.1831 13.0718C19.5816 11.7111 19.4811 9.62925 19.1818 8.43675C18.3923 5.29237 16.0449 3.423 12.5818 3.22238C9.30431 3.03244 6.34744 4.81369 5.07431 7.78425C4.65487 8.76281 4.43888 9.828 4.43888 11.1518C4.43888 15.1399 6.47325 17.883 9.98137 18.633C10.7818 18.7959 12.8257 18.8708 13.6357 18.6151C14.5046 20.0443 15.9026 21.2045 18.0158 20.3821L18.0169 20.3812ZM8.18438 13.5938C7.93688 12.4905 7.96331 9.86812 8.23299 8.78437C8.64006 7.14937 9.33006 6.12563 10.4249 5.53125C11.3965 5.10075 12.6017 5.03419 13.5017 5.45359C14.4801 5.91503 15.1596 6.84709 15.583 8.30734C15.9722 10.0258 16.0358 12.0348 15.5425 13.7823C15.3709 14.4106 15.1214 15.0268 14.8023 15.5857C14.0165 14.2997 12.2298 13.7351 10.891 14.2398L11.0789 15.5478C11.824 15.3771 12.8429 16.0897 12.895 16.7707C10.0563 17.198 8.81316 15.9026 8.18503 13.5926L8.18438 13.5938Z",
    fill: "#A82400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34659_477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuora);
export default __webpack_public_path__ + "static/media/quora.077fd0957b2abaf8d042b3c7ef5c85a8.svg";
export { ForwardRef as ReactComponent };